import React, { useState, useEffect } from 'react';
import FormRow from '../../../../common/formComponents/FormRow/FormRow';
import SelectField from '../../../../common/formComponents/SelectField/SelectField';
import { fieldNames } from '../constants';
import getName from '../../../../../../../helpers/getName';
import useAcceptanceExecutors from '../../../../../queries/useAcceptanceExecutors';

const WorkerIdsRow = ({ form }) => {
  const [executorsState, setExecutorsState] = useState([]);

  const { data: executors, isFetching } = useAcceptanceExecutors();

  useEffect(() => {
    let newExecutors = [];

    if (executors?.length) {
      newExecutors = executors.map((executor) => ({
        id: executor.id,
        name: getName(executor),
      }));
    }

    setExecutorsState(newExecutors);
  }, [executors]);

  return (
    <>
      <FormRow>
        <SelectField
          label="Ответственный"
          name={fieldNames.masterId}
          valueKey="id"
          contentKey="name"
          searchKey="name"
          selectProps={{
            showSearch: true,
            disabled: isFetching,
            optionFilterProp: 'searchtext',
            filterOption: (input, option) => {
              return (
                option.props.searchtext
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              );
            },
          }}
          selectOptions={executorsState}
          form={form}
          options={{
            rules: [
              {
                type: 'number',
                required: true,
                message: 'Укажите ответственного',
              },
            ],
          }}
        />
      </FormRow>
      <FormRow>
        <SelectField
          label="Сотрудники"
          name={fieldNames.workerIds}
          valueKey="id"
          contentKey="name"
          searchKey="name"
          selectProps={{
            disabled: isFetching,
            mode: 'multiple',
            optionFilterProp: 'searchtext',
            filterOption: (input, option) => {
              return (
                option.props.searchtext
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              );
            },
          }}
          selectOptions={executorsState}
          form={form}
          options={{
            rules: [
              {
                type: 'array',
                required: true,
                message: 'Укажите сотрудников',
              },
            ],
          }}
        />
      </FormRow>
    </>
  );
};

export default WorkerIdsRow;
